const basePanel = {
  '&.MuiPaper-elevation0': {
    '&.MuiCard-root': {
      padding: '24px 18px 24px 18px',
      width: '100%',
      overflow: 'hidden',
      '#edit-button': {
        visibility: 'hidden',
      },
    },
    '& .MuiCardHeader-root': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      margin: 0,
      padding: 0,
    },
    '& .MuiCardHeader-content': {
      display: 'flex',
      flex: 'none',
      flexDirection: 'row',
      svg: {
        width: '19px',
        height: '19px',
        marginRight: '10px',
      },
    },
    '& .MuiCardHeader-action': {
      margin: '0px',
      flex: 'none',
      display: 'flex',
    },
    '& .MuiCardContent-root': {
      padding: '8px 0px 0px 0px',
    },
  },
} as const;

export { basePanel };
